/**
 * @file documentAnnotator.variantGDotFind.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Sep 24, 2023 14:04
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import store from 'src/store';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { arrayExists, objectExists, objectHas, stringExists } from 'src/@common/utilities';

import {
    DOCUMENT_ANNOTATOR_VARIANT_GDOT_FIND_REQUEST,
    variantGDotFindSuccess,
    variantGDotFindFailure,
} from 'src/store/actions/documentAnnotator/documentAnnotatorDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/documentAnnotator/variantGDotFind';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            cDot: payload.cDot,
            transcript: payload.transcript,
            annotationId: payload.annotationId,
            variantId: payload.variantId
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* createRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.staticInfoMessage.options)
            );
        }

        if (objectExists(resp.payload)) {

            if (objectHas(resp.payload, 'serverMessages') &&
                arrayExists(resp.payload.serverMessages)) {

                resp.payload.serverMessages.forEach((item) => {

                    // note: had to use store.dispatch here because
                    // yield caused a reserved-word syntax error (why?)
                    store.dispatch(enqueueMessage(
                        item,
                        standardMessages.staticInfoMessage.options)
                    );

                });
            }
        }

        yield put(variantGDotFindSuccess(resp.payload));

        if (action.payload.notify === true) {

            if (objectHas(resp.payload, 'gDotObj.hg38.gDot')) {
                if (!stringExists(resp.payload.gDotObj.hg38.gDot)) {
                    // gDot not found
                    yield put(enqueueMessage(
                        'HG38 GDot could not be derived.',
                        standardMessages.infoMessage.options)
                    );
                }
            }

        }

    } catch (error) {
        yield put(variantGDotFindFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* createRequestMonitor() {
    yield takeLatest(DOCUMENT_ANNOTATOR_VARIANT_GDOT_FIND_REQUEST, createRequestSaga);
}
